import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text, ScrollView } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { Table, Row, Rows } from 'react-native-table-component';
import theme from './../../lib/theme.js';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import {
  LineChart,
  BarChart,
  PieChart,
  ProgressChart,
  ContributionGraph,
  StackedBarChart,
} from 'react-native-chart-kit';
import { apiFetch } from '../modules/api';

const DashboardRuta = () => {

  const [datos, setVentaOb] = useState({
    HeadTable1: ['Inventario Productos'],
    DataTable1: [

    ],

  })

  const [boton, setBoton] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [totales, setTotales] = useState({
    total_venta_cero: 0,
    total_inv_teorico: 0,
    total_inv_bodega: 0,
    total_inv_real: 0,
    total_inv_exhibido: 0,
  });


  async function fetchData() {
    setIsLoading(true);
    const datos = '{"empresa" : "' + gEmpresa + '","operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '"}'

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos
    }

    const response = await apiFetch(gApiPath + "/api/upcs", requestOptions);
    const json = await response.json();

    poblarTabla(json.datos);

  }




  useEffect(function () {
    let mounted = true;
    navigation.addListener('focus', () => {
      if (mounted) {
        try {

          fetchData();

        } catch {

          setBoton(1);

        }
      }
    });

    return () => mounted = false;
  }, []);

  const navigation = useNavigation();


  function poblarTabla(datos) {
    global.gDashboardTienda = {
      HeadTable1: ['Inventario Productos'],
      DataTable1: [

      ],

    }

    let x = 1;
    let venta_cero = ""
    const total = { ...totales };

    datos.forEach(i => {

      venta_cero = "No";

      if (i.estatus_upc == 2) {

        venta_cero = "Si";
        total.total_venta_cero += 1;
      }


      global.gDashboardTienda.DataTable1[x] = [i.descripcion];
      x = x + 1;
      global.gDashboardTienda.DataTable1[x] = ["UPC\n" + i.upc, "Inv. Teórico\n" + i.inv_teorico, "Venta cero\n" + venta_cero];
      x = x + 1;
      global.gDashboardTienda.DataTable1[x] = ['']
      x = x + 1;

      total.total_inv_teorico += i.inv_teorico === "" ? 0 : parseInt(i.inv_teorico);
      total.total_inv_bodega += i.inv_bodega_null ? 0 : parseInt(i.inv_bodega);
      total.total_inv_exhibido += i.inv_exhibido_null ? 0 : parseInt(i.inv_exhibido);

    });
    total.total_inv_real += (parseInt(total.total_inv_bodega) + parseInt(total.total_inv_exhibido));
    setTotales(total);
    setVentaOb(global.gDashboardTienda);
    setIsLoading(false);

  }


  function tiendas() {

    navigation.navigate('ListadoTiendas');

  }

  const getDeterminanteDetalle = (data, opc) => {
    const text = data.split("-");
    if (opc === 1) {
      if (text.length > 0) {
        return text[0].trim();
      }
    }
    if (opc === 2) {
      if (text.length > 1) {
        return text[1].trim();
      }
    }
    return "";
  }

  const Spacer = ({ height = 16 }) => <View style={{ height }} />;

  return (
    <View style={styles.container}>
      <Fondo />
      <View style={{ height: 130, width: "100%" }} >
        <View
          style={{
            ...theme.cards, backgroundColor: "#fff",
            flexWrap: 'wrap', flex: 1, height: 130, maxHeight: 150, justifyContent: "center"
          }}>
          <View style={{ alignItems: 'center', justifyContent: "center", height: "100%", marginRight: 10 }}>
            <MaterialCommunityIcons style={{ textAlign: 'center', marginTop: -10 }} name="store" size={50} color="#333" />
          </View>
          <View style={{ whiteSpace: "nowrap", maxWidth: 300 }}>
            <Text style={{ ...theme.subTitle, fontWeight: 'bold' }} ellipsizeMode="tail" numberOfLines={2}>{gOperador.toUpperCase() + " - " + gDeterminante.toUpperCase()}</Text>
            <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{getDeterminanteDetalle(gDeterminanteDetalle, 1)}{ }</Text>
            <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{getDeterminanteDetalle(gDeterminanteDetalle, 2)}{ }</Text>
          </View>
        </View>
      </View>
      <View style={{ textAlign: 'center' }}>
        <Text style={{ ...theme.subTitle, fontWeight: 'bold', textAlign: 'center' }}> Total Inventario</Text>
        
      </View>
      {!isLoading ? (
          <View style={{ ...styles.tableContainer, width: "100%" }}>
            <Table >
              <Row data={datos.HeadTable1} style={styles.text} textStyle={styles.text} />
            </Table>
            <ScrollView style={{height: "100%", marginBottom: "10%"}}>
              <Table borderStyle={{ paddingTop: 40, borderWidth: 1, borderColor: '#CCC', backgroundColor: "#FFF" }} style={{ borderRadius: 10, borderColor: "#CCC", borderStyle: "solid", borderWidth: 1, paddingBottom: 50 }}>
                <Rows data={datos.DataTable1} style={styles.TableText} textStyle={styles.TableText} />
              </Table>
              <Text style={{ ...theme.subTitle2, marginRight: '5%' }}>Real: <Text style={{ ...theme.subTitle2, fontWeight: 'bold' }}> {totales.total_inv_real}</Text></Text>
             </ScrollView >
          </View>
      ) : (
       <Text>Cargando...</Text>
      )}
    </View>
  );
}

export default DashboardRuta

const styles = StyleSheet.create({
  header: {
    marginHorizontal: 20,
    width: '100%',
    height: '20%'
  },
  container: {
    backgroundColor: '#f1f1f1',
    alignItems: 'center',
  },
  tableContainer: {
    padding: 10,
    backgroundColor: 'white',
    color: "white",
    width: "100%",
    maxHeight: "100%"
  },
  HeadStyle: {
    height: 20,
    alignContent: "center",
    color: "white",
    backgroundColor: 'white'
  },
  TableText: {
    fontSize: 14,
    textAlign: 'center',
    color: "black",
    fontWeight: 'bold',
    backgroundColor: "#fff",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 50,
  },
  text: {
    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#23abdc",
    textAlign: 'center',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
  },
  textSimple: {
    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#23abdc",
    textAlign: 'center',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  TableTextSimple: {
    fontSize: 14,
    textAlign: 'center',
    color: "black",
    fontWeight: 'bold',
    backgroundColor: "#fff",
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    borderBottomLeftRadius: 100,
    borderBottomRightRadius: 100,
  },
  TituloText: {
    fontSize: 30,
    margin: 5,
    textAlign: 'center',
    color: "black",
    fontWeight: 'bold'
  }
});